import React from "react";
import { FormGroup, Label, FormFeedback } from "reactstrap";
import classNames from "classnames";

const CheckboxGroup: React.FC<{
  value?: any;
  error?: any;
  touched?: any;
  id?: any;
  label?: any;
  className?: any;
  required?: any;
  questionCount?: any;
}> = ({ value, error, touched, id, label, className, questionCount, ...props }) => {
  const classes = classNames(
    "input-field",
    
    {
      "is-success": value || (!error && touched), // handle prefilled or user-filled
      "is-error": !!error && touched,
    },
    className
  );

  return (
    <FormGroup className={classes}>
      <fieldset>
        {label && (
          <Label className="control-label">
            {questionCount && <span className="question-count">{questionCount}</span>}
            {label} {props.required && <span className="text-danger">*</span>}
          </Label>
        )}
        {props.children}
        {touched && error && <FormFeedback>{error}</FormFeedback>}
      </fieldset>
    </FormGroup>
  );
};

export default CheckboxGroup;
